module.exports = __webpack_public_path__ + "img/YouthHeader.b284a3be.jpg";